import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import Layout from "./Component/Layout";
import './Assets/css/chat.css'
import './Assets/css/utilities.css'
import './Assets/css/style.css'
import './Assets/css/responsive.css'
function App() {
  return (
    <BrowserRouter>
        {/* <Layout> */}
          <AppRoutes />
        {/* </Layout> */}
    </BrowserRouter>
  );
}

export default App;
